import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { REGION_REGISTRY_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_LIST = '_LOAD_LIST';
export const LOAD_SZLT_LIST = '_LOAD_SZLT_LIST';
export const CREATE_SZLT = '_CREATE_SZLT';
export const LOAD_SZLT_BY_ID = '_LOAD_SZLT_BY_ID';
export const ASSIGN_SZLT_BY_ID = '_ASSIGN_SZLT_BY_ID';
export const EDIT_SZLT_BY_ID = '_EDIT_SZLT_BY_ID';
export const ARCHIVE_SZLT = '_ARCHIVE_SZLT';
export const UNARCHIVE_SZLT = '_UNARCHIVE_SZLT';
export const DELETE_SZLT = '_DELETE_SZLT';
export const ANNULMENT_SZLT = '_ANNULMENT_SZLT';
export const LOAD_CARRIER_LIST = '_LOAD_CARRIER_LIST';
export const CREATE_CARRIER = '_CREATE_CARRIER';
export const LOAD_CARRIER_BY_ID = '_LOAD_CARRIER_BY_ID';
export const EDIT_CARRIER_BY_ID = '_EDIT_CARRIER_BY_ID';
export const DELETE_CARRIER = '_DELETE_CARRIER';
export const ANNULMENT_CARRIER = '_ANNULMENT_CARRIER';
export const ARCHIVE_CARRIER = '_ARCHIVE_CARRIER';
export const UNARCHIVE_CARRIER = '_UNARCHIVE_CARRIER';
export const LOAD_VEHICLES_LIST = '_LOAD_VEHICLES_LIST';
export const CREATE_VEHICLES = '_CREATE_VEHICLES';
export const LOAD_VEHICLES_BY_ID = '_LOAD_VEHICLES_BY_ID';
export const EDIT_VEHICLES_BY_ID = '_EDIT_VEHICLES_BY_ID';
export const DELETE_VEHICLES = '_DELETE_VEHICLES';
export const ANNULMENT_VEHICLES = '_ANNULMENT_VEHICLES';
export const ARCHIVE_VEHICLES = '_ARCHIVE_VEHICLES';
export const UNARCHIVE_VEHICLES = '_UNARCHIVE_VEHICLES';
export const VEHICLES_HELPER = '_VEHICLES_HELPER';
export const CARRIER_HELPER = '_CARRIER_HELPER';
export const SZLT_HELPER = '_SZLT_HELPER';
export const LOAD_REGISTRY_HISTORY_LIST = '_LOAD_REGISTRY_HISTORY_LIST';
export const LOAD_REGISTRY_EXPORT_LIST = '_LOAD_REGISTRY_EXPORT_LIST';
export const LOAD_REGISTRY_SMEV_CHECK_LIST = '_LOAD_REGISTRY_SMEV_CHECK_LIST';
export const IMPORT_CARRIER = '_IMPORT_CARRIER';
export const IMPORT_VEHICLES = '_IMPORT_VEHICLES';
export const IMPORT_SZLT = '_IMPORT_SZLT';
export const IMPORT_CARRIER_VEHICLE = '_IMPORT_CARRIER_VEHICLE';
export const EXPORT_CARRIER = '_EXPORT_CARRIER';
export const EXPORT_VEHICLES = '_EXPORT_VEHICLES';
export const EXPORT_SZLT = '_EXPORT_SZLT';
export const LOAD_SMEV_CHECK_CARRIER_LIST = '_LOAD_SMEV_CHECK_CARRIER_LIST';
export const LOAD_SMEV_CHECK_SZLT_LIST = '_LOAD_SMEV_CHECK_SZLT_LIST';
export const LOAD_SMEV_CHECK_VEHICLE_LIST = '_LOAD_SMEV_CHECK_VEHICLE_LIST';
export const SMEV_CHECK_ALL_CARRIER = '_SMEV_CHECK_ALL_CARRIER';
export const SMEV_CHECK_ALL_SZLT = '_SMEV_CHECK_ALL_SZLT';
export const SMEV_CHECK_ALL_VEHICLES = '_SMEV_CHECK_ALL_VEHICLES';
export const CREATE_CARRIER_STATEMENT = '_CREATE_CARRIER_STATEMENT';
export const CREATE_VEHICLES_STATEMENT = '_CREATE_VEHICLES_STATEMENT';
export const CREATE_SZLT_STATEMENT = '_CREATE_SZLT_STATEMENT';
export const INACTIVE_CARRIER = '_INACTIVE_CARRIER';
export const INACTIVE_SZLT = '_INACTIVE_SZLT';
export const RESUMED_CARRIER = '_RESUMED_CARRIER';
export const RESUMED_SZLT = '_RESUMED_SZLT';
export const SEND_CARRIER_FGIS_TAXI = '_SEND_CARRIER_FGIS_TAXI';
export const SEND_VEHICLES_FGIS_TAXI = '_SEND_VEHICLES_FGIS_TAXI';
export const SEND_SZLT_FGIS_TAXI = '_SEND_SZLT_FGIS_TAXI';
export const EXTRACT_SZLT = '_EXTRACT_SZLT';
export const EXTRACT_CARRIER = '_EXTRACT_CARRIER';
export const EXTRACT_VEHICLES = '_EXTRACT_VEHICLES';
export const CARRIER_FIELDS_VALIDATION = '_CARRIER_FIELDS_VALIDATION';
export const VEHICLE_FIELDS_VALIDATION = '_VEHICLE_FIELDS_VALIDATION';
export const SZLT_FIELDS_VALIDATION = '_SZLT_FIELDS_VALIDATION';
export const LOAD_RELATION_CARRIER_VEHICLE_LIST = '_LOAD_RELATION_CARRIER_VEHICLE_LIST';
export const LOAD_RELATION_CARRIER_SZLT_LIST = '_LOAD_RELATION_CARRIER_SZLT_LIST';
export const LOAD_RELATION_VEHICLE_SZLT_LIST = '_LOAD_RELATION_VEHICLE_SZLT_LIST';
export const LOAD_STATUS_IMPORT = '_LOAD_STATUS_IMPORT';
export const LOAD_CARRIER_LIST_MODAL = '_LOAD_CARRIER_LIST_MODAL';
export const LOAD_SZLT_LIST_MODAL = '_LOAD_SZLT_LIST_MODAL';
export const LOAD_VEHICLES_LIST_MODAL = '_LOAD_VEHICLES_LIST_MODAL';
export const EXPORT_OSAGO = '_EXPORT_OSAGO';
export const IMPORT_OSAGO = '_IMPORT_OSAGO';
export const RESTORE_CARRIER = '_RESTORE_CARRIER';
export const RESTORE_SZLT = '_RESTORE_SZLT';
export const RESTORE_VEHICLES = '_RESTORE_VEHICLES';
export const LOAD_CARRIER_LIST_ID = 'LOAD_CARRIER_LIST_ID';
export const LOAD_SZLT_LIST_ID = 'LOAD_SZLT_LIST_ID';
export const LOAD_VEHICLE_LIST_ID = 'LOAD_VEHICLE_LIST_ID';
export const BATCH_COMMAND_SZLT = 'BATCH_COMMAND_SZLT';
export const BATCH_COMMAND_VEHICLE = 'BATCH_COMMAND_VEHICLE';
export const BATCH_COMMAND_CARRIER = 'BATCH_COMMAND_CARRIER';

export const loadSZLTList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST);
export const loadSZLTListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + BEGIN);
export const loadSZLTListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + SUCCESSFUL);
export const loadSZLTListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + FAILED);

export const createSZLT = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_SZLT);
export const createSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_SZLT + SUCCESSFUL);
export const createSZLTFailed = createAction(REGION_REGISTRY_MODULE + CREATE_SZLT + FAILED);

export const loadSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID);
export const loadSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID + SUCCESSFUL);
export const loadSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID + FAILED);

export const assignSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + ASSIGN_SZLT_BY_ID);
export const assignSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + ASSIGN_SZLT_BY_ID + SUCCESSFUL);
export const assignSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + ASSIGN_SZLT_BY_ID + FAILED);

export const editSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + EDIT_SZLT_BY_ID);
export const editSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EDIT_SZLT_BY_ID + SUCCESSFUL);
export const editSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + EDIT_SZLT_BY_ID + FAILED);

export const archiveSZLT = createDeferredAction(REGION_REGISTRY_MODULE + ARCHIVE_SZLT);
export const archiveSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + ARCHIVE_SZLT + SUCCESSFUL);
export const archiveSZLTFailed = createAction(REGION_REGISTRY_MODULE + ARCHIVE_SZLT + FAILED);

export const unarchiveSZLT = createDeferredAction(REGION_REGISTRY_MODULE + UNARCHIVE_SZLT);
export const unarchiveSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_SZLT + SUCCESSFUL);
export const unarchiveSZLTFailed = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_SZLT + FAILED);

export const deleteSZLT = createDeferredAction(REGION_REGISTRY_MODULE + DELETE_SZLT);
export const deleteSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + DELETE_SZLT + SUCCESSFUL);
export const deleteSZLTFailed = createAction(REGION_REGISTRY_MODULE + DELETE_SZLT + FAILED);

export const annulmentSZLT = createDeferredAction(REGION_REGISTRY_MODULE + ANNULMENT_SZLT);
export const annulmentSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + ANNULMENT_SZLT + SUCCESSFUL);
export const annulmentSZLTFailed = createAction(REGION_REGISTRY_MODULE + ANNULMENT_SZLT + FAILED);

export const loadCarrierList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST);
export const loadCarrierListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + BEGIN);
export const loadCarrierListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + SUCCESSFUL);
export const loadCarrierListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + FAILED);

export const createCarrier = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_CARRIER);
export const createCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_CARRIER + SUCCESSFUL);
export const createCarrierFailed = createAction(REGION_REGISTRY_MODULE + CREATE_CARRIER + FAILED);

export const loadCarrierById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID);
export const loadCarrierByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID + SUCCESSFUL);
export const loadCarrierByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID + FAILED);

export const editCarrierById = createDeferredAction(REGION_REGISTRY_MODULE + EDIT_CARRIER_BY_ID);
export const editCarrierByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EDIT_CARRIER_BY_ID + SUCCESSFUL);
export const editCarrierByIdFailed = createAction(REGION_REGISTRY_MODULE + EDIT_CARRIER_BY_ID + FAILED);

export const deleteCarrier = createDeferredAction(REGION_REGISTRY_MODULE + DELETE_CARRIER);
export const deleteCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + DELETE_CARRIER + SUCCESSFUL);
export const deleteCarrierFailed = createAction(REGION_REGISTRY_MODULE + DELETE_CARRIER + FAILED);

export const annulmentCarrier = createDeferredAction(REGION_REGISTRY_MODULE + ANNULMENT_CARRIER);
export const annulmentCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + ANNULMENT_CARRIER + SUCCESSFUL);
export const annulmentCarrierFailed = createAction(REGION_REGISTRY_MODULE + ANNULMENT_CARRIER + FAILED);

export const archiveCarrier = createDeferredAction(REGION_REGISTRY_MODULE + ARCHIVE_CARRIER);
export const archiveCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + ARCHIVE_CARRIER + SUCCESSFUL);
export const archiveCarrierFailed = createAction(REGION_REGISTRY_MODULE + ARCHIVE_CARRIER + FAILED);

export const unarchiveCarrier = createDeferredAction(REGION_REGISTRY_MODULE + UNARCHIVE_CARRIER);
export const unarchiveCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_CARRIER + SUCCESSFUL);
export const unarchiveCarrierFailed = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_CARRIER + FAILED);

export const loadVehiclesList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST);
export const loadVehiclesListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + BEGIN);
export const loadVehiclesListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + SUCCESSFUL);
export const loadVehiclesListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + FAILED);

export const createVehicles = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES);
export const createVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES + SUCCESSFUL);
export const createVehiclesFailed = createAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES + FAILED);

export const loadVehiclesById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID);
export const loadVehiclesByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID + SUCCESSFUL);
export const loadVehiclesByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID + FAILED);

export const editVehiclesById = createDeferredAction(REGION_REGISTRY_MODULE + EDIT_VEHICLES_BY_ID);
export const editVehiclesByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EDIT_VEHICLES_BY_ID + SUCCESSFUL);
export const editVehiclesByIdFailed = createAction(REGION_REGISTRY_MODULE + EDIT_VEHICLES_BY_ID + FAILED);

export const deleteVehicles = createDeferredAction(REGION_REGISTRY_MODULE + DELETE_VEHICLES);
export const deleteVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + DELETE_VEHICLES + SUCCESSFUL);
export const deleteVehiclesFailed = createAction(REGION_REGISTRY_MODULE + DELETE_VEHICLES + FAILED);

export const restoreVehicles = createDeferredAction(REGION_REGISTRY_MODULE + RESTORE_VEHICLES);
export const restoreVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + RESTORE_VEHICLES + SUCCESSFUL);
export const restoreVehiclesFailed = createAction(REGION_REGISTRY_MODULE + RESTORE_VEHICLES + FAILED);

export const restoreSZLT = createDeferredAction(REGION_REGISTRY_MODULE + RESTORE_SZLT);
export const restoreSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + RESTORE_SZLT + SUCCESSFUL);
export const restoreSZLTFailed = createAction(REGION_REGISTRY_MODULE + RESTORE_SZLT + FAILED);

export const restoreCarrier = createDeferredAction(REGION_REGISTRY_MODULE + RESTORE_CARRIER);
export const restoreCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + RESTORE_CARRIER + SUCCESSFUL);
export const restoreCarrierFailed = createAction(REGION_REGISTRY_MODULE + RESTORE_CARRIER + FAILED);

export const annulmentVehicles = createDeferredAction(REGION_REGISTRY_MODULE + ANNULMENT_VEHICLES);
export const annulmentVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + ANNULMENT_VEHICLES + SUCCESSFUL);
export const annulmentVehiclesFailed = createAction(REGION_REGISTRY_MODULE + ANNULMENT_VEHICLES + FAILED);

export const archiveVehicles = createDeferredAction(REGION_REGISTRY_MODULE + ARCHIVE_VEHICLES);
export const archiveVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + ARCHIVE_VEHICLES + SUCCESSFUL);
export const archiveVehiclesFailed = createAction(REGION_REGISTRY_MODULE + ARCHIVE_VEHICLES + FAILED);

export const unarchiveVehicles = createDeferredAction(REGION_REGISTRY_MODULE + UNARCHIVE_VEHICLES);
export const unarchiveVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_VEHICLES + SUCCESSFUL);
export const unarchiveVehiclesFailed = createAction(REGION_REGISTRY_MODULE + UNARCHIVE_VEHICLES + FAILED);

export const vehiclesHelper = createDeferredAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER);
export const vehiclesHelperSuccessful = createAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER + SUCCESSFUL);
export const vehiclesHelperFailed = createAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER + FAILED);

export const carrierHelper = createDeferredAction(REGION_REGISTRY_MODULE + CARRIER_HELPER);
export const carrierHelperSuccessful = createAction(REGION_REGISTRY_MODULE + CARRIER_HELPER + SUCCESSFUL);
export const carrierHelperFailed = createAction(REGION_REGISTRY_MODULE + CARRIER_HELPER + FAILED);

export const szltHelper = createDeferredAction(REGION_REGISTRY_MODULE + SZLT_HELPER);
export const szltHelperSuccessful = createAction(REGION_REGISTRY_MODULE + SZLT_HELPER + SUCCESSFUL);
export const szltHelperFailed = createAction(REGION_REGISTRY_MODULE + SZLT_HELPER + FAILED);

export const loadRegistryHistoryList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST);
export const loadRegistryHistoryListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST + BEGIN);
export const loadRegistryHistoryListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST + SUCCESSFUL);
export const loadRegistryHistoryListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_HISTORY_LIST + FAILED);

export const loadRegistryExportList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST);
export const loadRegistryExportListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST + BEGIN);
export const loadRegistryExportListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST + SUCCESSFUL);
export const loadRegistryExportListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_EXPORT_LIST + FAILED);

export const loadRegistrySmevCheckList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST);
export const loadRegistrySmevCheckListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST + BEGIN);
export const loadRegistrySmevCheckListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST + SUCCESSFUL);
export const loadRegistrySmevCheckListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_REGISTRY_SMEV_CHECK_LIST + FAILED);

export const importCarrier = createDeferredAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER);
export const importCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER + SUCCESSFUL);
export const importCarrierFailed = createAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER + FAILED);

export const importVehicles = createDeferredAction(REGION_REGISTRY_MODULE + IMPORT_VEHICLES);
export const importVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + IMPORT_VEHICLES + SUCCESSFUL);
export const importVehiclesFailed = createAction(REGION_REGISTRY_MODULE + IMPORT_VEHICLES + FAILED);

export const importSZLT = createDeferredAction(REGION_REGISTRY_MODULE + IMPORT_SZLT);
export const importSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + IMPORT_SZLT + SUCCESSFUL);
export const importSZLTFailed = createAction(REGION_REGISTRY_MODULE + IMPORT_SZLT + FAILED);

export const importCarrierVehicle = createDeferredAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER_VEHICLE);
export const importCarrierVehicleSuccessful = createAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER_VEHICLE + SUCCESSFUL);
export const importCarrierVehicleFailed = createAction(REGION_REGISTRY_MODULE + IMPORT_CARRIER_VEHICLE + FAILED);

export const exportCarrier = createDeferredAction(REGION_REGISTRY_MODULE + EXPORT_CARRIER);
export const exportCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + EXPORT_CARRIER + SUCCESSFUL);
export const exportCarrierFailed = createAction(REGION_REGISTRY_MODULE + EXPORT_CARRIER + FAILED);

export const exportVehicles = createDeferredAction(REGION_REGISTRY_MODULE + EXPORT_VEHICLES);
export const exportVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + EXPORT_VEHICLES + SUCCESSFUL);
export const exportVehiclesFailed = createAction(REGION_REGISTRY_MODULE + EXPORT_VEHICLES + FAILED);

export const exportSZLT = createDeferredAction(REGION_REGISTRY_MODULE + EXPORT_SZLT);
export const exportSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + EXPORT_SZLT + SUCCESSFUL);
export const exportSZLTFailed = createAction(REGION_REGISTRY_MODULE + EXPORT_SZLT + FAILED);

export const loadSmevCheckCarrierList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_CARRIER_LIST);
export const loadSmevCheckCarrierListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_CARRIER_LIST + SUCCESSFUL);
export const loadSmevCheckCarrierListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_CARRIER_LIST + FAILED);

export const loadSmevCheckSZLTList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_SZLT_LIST);
export const loadSmevCheckSZLTListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_SZLT_LIST + SUCCESSFUL);
export const loadSmevCheckSZLTListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_SZLT_LIST + FAILED);

export const loadSmevCheckVehicleList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_VEHICLE_LIST);
export const loadSmevCheckVehicleListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_VEHICLE_LIST + SUCCESSFUL);
export const loadSmevCheckVehicleListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SMEV_CHECK_VEHICLE_LIST + FAILED);

export const smevCheckAllCarrier = createDeferredAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_CARRIER);
export const smevCheckAllCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_CARRIER + SUCCESSFUL);
export const smevCheckAllCarrierFailed = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_CARRIER + FAILED);

export const smevCheckAllSZLT = createDeferredAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_SZLT);
export const smevCheckAllSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_SZLT + SUCCESSFUL);
export const smevCheckAllSZLTFailed = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_SZLT + FAILED);

export const smevCheckAllVehicles = createDeferredAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_VEHICLES);
export const smevCheckAllVehiclesSuccessful = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_VEHICLES + SUCCESSFUL);
export const smevCheckAllVehiclesFailed = createAction(REGION_REGISTRY_MODULE + SMEV_CHECK_ALL_VEHICLES + FAILED);

export const createCarrierStatement = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_CARRIER_STATEMENT);
export const createCarrierStatementSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_CARRIER_STATEMENT + SUCCESSFUL);
export const createCarrierStatementFailed = createAction(REGION_REGISTRY_MODULE + CREATE_CARRIER_STATEMENT + FAILED);

export const createVehiclesStatement = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES_STATEMENT);
export const createVehiclesStatementSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES_STATEMENT + SUCCESSFUL);
export const createVehiclesStatementFailed = createAction(REGION_REGISTRY_MODULE + CREATE_VEHICLES_STATEMENT + FAILED);

export const createSZLTStatement = createDeferredAction(REGION_REGISTRY_MODULE + CREATE_SZLT_STATEMENT);
export const createSZLTStatementSuccessful = createAction(REGION_REGISTRY_MODULE + CREATE_SZLT_STATEMENT + SUCCESSFUL);
export const createSZLTStatementFailed = createAction(REGION_REGISTRY_MODULE + CREATE_SZLT_STATEMENT + FAILED);

export const inactiveCarrier = createDeferredAction(REGION_REGISTRY_MODULE + INACTIVE_CARRIER);
export const inactiveCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + INACTIVE_CARRIER + SUCCESSFUL);
export const inactiveCarrierFailed = createAction(REGION_REGISTRY_MODULE + INACTIVE_CARRIER + FAILED);

export const inactiveSZLT = createDeferredAction(REGION_REGISTRY_MODULE + INACTIVE_SZLT);
export const inactiveSZLTSuccessful = createAction(REGION_REGISTRY_MODULE + INACTIVE_SZLT + SUCCESSFUL);
export const inactiveSZLTFailed = createAction(REGION_REGISTRY_MODULE + INACTIVE_SZLT + FAILED);

export const resumedCarrier = createDeferredAction(REGION_REGISTRY_MODULE + RESUMED_CARRIER);
export const resumedCarrierSuccessful = createAction(REGION_REGISTRY_MODULE + RESUMED_CARRIER + SUCCESSFUL);
export const resumedCarrierFailed = createAction(REGION_REGISTRY_MODULE + RESUMED_CARRIER + FAILED);

export const resumedSZLT = createDeferredAction(REGION_REGISTRY_MODULE + RESUMED_SZLT);
export const resumedSZLTSSuccessful = createAction(REGION_REGISTRY_MODULE + RESUMED_SZLT + SUCCESSFUL);
export const resumedSZLTSFailed = createAction(REGION_REGISTRY_MODULE + RESUMED_SZLT + FAILED);

export const sendCarrierFgisTaxi = createDeferredAction(REGION_REGISTRY_MODULE + SEND_CARRIER_FGIS_TAXI);
export const sendCarrierFgisTaxiSuccessful = createAction(REGION_REGISTRY_MODULE + SEND_CARRIER_FGIS_TAXI + SUCCESSFUL);
export const sendCarrierFgisTaxiFailed = createAction(REGION_REGISTRY_MODULE + SEND_CARRIER_FGIS_TAXI + FAILED);

export const sendVehiclesFgisTaxi = createDeferredAction(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI);
export const sendVehiclesFgisTaxiSuccessful = createAction(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI + SUCCESSFUL);
export const sendVehiclesFgisTaxiFailed = createAction(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI + FAILED);

export const sendSzltFgisTaxi = createDeferredAction(REGION_REGISTRY_MODULE + SEND_SZLT_FGIS_TAXI);
export const sendSzltFgisTaxiSuccessful = createAction(REGION_REGISTRY_MODULE + SEND_SZLT_FGIS_TAXI + SUCCESSFUL);
export const sendSzltFgisTaxiFailed = createAction(REGION_REGISTRY_MODULE + SEND_SZLT_FGIS_TAXI + FAILED);

export const extractVehiciesById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES);
export const extractVehiciesByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES + SUCCESSFUL);
export const extractVehiciesByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES + FAILED);

export const extractSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT);
export const extractSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT + SUCCESSFUL);
export const extractSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT + FAILED);

export const extractCarrierById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER);
export const extractCarrierByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER + SUCCESSFUL);
export const extractCarrierByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER + FAILED);

export const loadCarrierFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION);
export const loadCarrierFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION + SUCCESSFUL);
export const loadCarrierFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION + FAILED);

export const loadVehicleFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION);
export const loadVehicleFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION + SUCCESSFUL);
export const loadVehicleFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION + FAILED);

export const loadSZLTFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION);
export const loadSZLTFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION + SUCCESSFUL);
export const loadSZLTFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION + FAILED);

export const loadRelationCarrierVehicleList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST);
export const loadRelationCarrierVehicleSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + SUCCESSFUL);
export const loadRelationCarrierVehicleFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + FAILED);
export const loadRelationCarrierVehicleBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + BEGIN);
export const loadRelationCarrierVehicleClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + CLEAR);

export const loadRelationCarrierSzltList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST);
export const loadRelationCarrierSzltBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + BEGIN);
export const loadRelationCarrierSzltSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + SUCCESSFUL);
export const loadRelationCarrierSzltFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + FAILED);
export const loadRelationCarrierSzltListClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + CLEAR);

export const loadRelationVehicleSzltList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST);
export const loadRelationVehicleSzltListBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + BEGIN);
export const loadRelationVehicleSzltListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + SUCCESSFUL);
export const loadRelationVehicleSzltListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + FAILED);
export const loadRelationVehicleSzltListClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + CLEAR);

export const loadStatusImport = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT);
export const loadStatusImportSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT + SUCCESSFUL);
export const loadStatusImportFailed = createAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT + FAILED);

export const loadCarrierListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL);
export const loadCarrierListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + BEGIN);
export const loadCarrierListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + SUCCESSFUL);
export const loadCarrierListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + FAILED);

export const loadSZLTListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL);
export const loadSZLTListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + BEGIN);
export const loadSZLTListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + SUCCESSFUL);
export const loadSZLTListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + FAILED);

export const loadVehiclesListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL);
export const loadVehiclesListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + BEGIN);
export const loadVehiclesListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + SUCCESSFUL);
export const loadVehiclesListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + FAILED);

export const importOsago = createDeferredAction(REGION_REGISTRY_MODULE + IMPORT_OSAGO);
export const importOsagoSuccessful = createAction(REGION_REGISTRY_MODULE + IMPORT_OSAGO + SUCCESSFUL);
export const importOsagoFailed = createAction(REGION_REGISTRY_MODULE + IMPORT_OSAGO + FAILED);

export const exportOsago = createDeferredAction(REGION_REGISTRY_MODULE + EXPORT_OSAGO);
export const exportOsagoSuccessful = createAction(REGION_REGISTRY_MODULE + EXPORT_OSAGO + SUCCESSFUL);
export const exportOsagoFailed = createAction(REGION_REGISTRY_MODULE + EXPORT_OSAGO + FAILED);

export const loadCarrierIdList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_ID);
export const loadCarrierIdListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_ID + BEGIN);
export const loadCarrierIdListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_ID + SUCCESSFUL);
export const loadCarrierIdListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_ID + FAILED);

export const loadSzltIdList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_ID);
export const loadSzltIdListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_ID + BEGIN);
export const loadSzltIdListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_ID + SUCCESSFUL);
export const loadSzltIdListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_ID + FAILED);

export const loadVehicleIdList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLE_LIST_ID);
export const loadVehicleIdListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLE_LIST_ID + BEGIN);
export const loadVehicleIdListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLE_LIST_ID + SUCCESSFUL);
export const loadVehicleIdListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLE_LIST_ID + FAILED);

export const carrierRegistryBatchCommand = createDeferredAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_CARRIER);
export const carrierRegistryBatchCommandSuccessful = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_CARRIER + SUCCESSFUL);
export const carrierRegistryBatchCommandFailed = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_CARRIER + FAILED);

export const szltRegistryBatchCommand = createDeferredAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_SZLT);
export const szltRegistryBatchCommandSuccessful = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_SZLT + SUCCESSFUL);
export const szltRegistryBatchCommandFailed = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_SZLT + FAILED);

export const vehicleRegistryBatchCommand = createDeferredAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_VEHICLE);
export const vehicleRegistryBatchCommandSuccessful = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_VEHICLE + SUCCESSFUL);
export const vehicleRegistryBatchCommandFailed = createAction(REGION_REGISTRY_MODULE + BATCH_COMMAND_VEHICLE + FAILED);
